__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "my-app";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@maas-components/styles", "4.19.2", () => (() => (__webpack_require__(69974))), 1);
			register("@maas-components/styles", "4.19.2", () => (() => (__webpack_require__(79860))), 1);
			register("@material-ui/core", "4.12.4", () => (() => (__webpack_require__(54406))), 1);
			register("@material-ui/core", "4.12.4", () => (() => (__webpack_require__(83172))), 1);
			register("@material-ui/styles", "4.11.5", () => (() => (__webpack_require__(88802))), 1);
			register("@material-ui/styles", "4.11.5", () => (() => (__webpack_require__(31808))), 1);
			register("@ugc-components/context", "1.2.0", () => (() => (__webpack_require__(74413))), 1);
			register("react-dom", "18.3.1", () => (() => (__webpack_require__(3593))), 1);
			register("react-router-dom", "5.3.4", () => (() => (__webpack_require__(33711))), 1);
			register("react-router-dom", "5.3.4", () => (() => (__webpack_require__(65196))), 1);
			register("react", "16.14.0", () => (() => (__webpack_require__(41077))), 1);
			register("react", "18.3.1", () => (() => (__webpack_require__(52660))), 1);
			register("styled-components", "5.3.11", () => (() => (__webpack_require__(80295))), 1);
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};